import { MutableRefObject, Ref, useCallback } from "react";

type MergeableRef<T> = Ref<T> | MutableRefObject<T | null> | null | undefined;

/**
 * Combines multiple refs (callback refs and/or object refs) into a single
 * callback ref that can be passed to a DOM element. Useful when a component
 * forwards a ref but also needs an internal ref to the same node.
 */
export const useMergedRefs = <T>(...refs: MergeableRef<T>[]) => {
  return useCallback((node: T | null) => {
    refs.forEach((ref) => {
      if (!ref) return;
      if (typeof ref === "function") {
        ref(node);
      } else {
        (ref as MutableRefObject<T | null>).current = node;
      }
    });
  }, refs);
};
